// The payment list (GET /api/contracts/me) recalculates minimumPayment.
// The contract detail query returns the stored column, which can be an older period.
// ยอดเงินที่ต้องชำระ uses the list figure. A missing list row is not the stored column.

export function amountDue(detailContract, listContracts) {
  if (!detailContract) return null;
  const listed = (listContracts || []).find(
    (contract) => contract && contract.id === detailContract.id
  );
  if (!listed || listed.minimumPayment == null) return null;
  return listed.minimumPayment;
}
